import axios from "axios";
import { useCallback,useState } from "react";
import { leaseService } from "../../../../../../configs/constants";

export const useClearCheque = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const clearCheque = useCallback(async ({ leaseId, pdcId, subPdc, isCleared = true, clearedDate }) => {
    setLoading(true);
    setError(null);

    try {
      const url = `${leaseService}/booking/clearCheque/${leaseId}/${pdcId}`;

      const data = { isCleared, ...(subPdc && { subPdc }), ...(clearedDate && { clearedDate }) };
      const response = await axios.patch(url, data);

      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { clearCheque, loading, error };
};
